import { Editable, Slate, withReact } from 'slate-react'
import { compose } from 'ramda'
import { createEditor } from 'slate'
import { useIsMaster } from '@btime/react-session'
import { withHistory } from 'slate-history'
import React from 'react'

import { renderElement, renderLeaf } from '../_plugins/plugins'
import { useEditorKeydown } from '../_plugins/keydowns'
import { useUploadRequest } from '../../../../utils/hooks/uploadV2'
import DocumentControlBar from './DocumentControlBar'
import EditorContext from '../EditorContext'
import ImagePlugin from '../_plugins/ImagePlugin'
import InterpolationPlugin from '../_plugins/InterpolationPlugin'
import LinkPlugin from '../_plugins/LinkPlugin'
import Panel from '../../../kiti/components/structure/Panel'
import Separator from '../../../kiti/components/helpers/Separator'
import SeparatorPlugin from '../_plugins/SeparatorPlugin'

const MarkdownEditor = ({ value, onChange, interpolations }) => {
  // TODO: Receive upload as param
  const [upload] = useUploadRequest()

  const [editor] = React.useState(() =>
    compose(
      InterpolationPlugin.extend({ fullControl: true }), //
      ImagePlugin.extend(upload, { fullControl: true }),
      SeparatorPlugin.extend,
      LinkPlugin.extend,
      withReact,
      withHistory
    )(createEditor())
  )

  // TODO: Receive if can use raw interpolations as params
  editor.canUseRawInterpolation = useIsMaster()

  const initialValue = value || [{ type: 'paragraph', children: [{ text: '' }] }]

  return (
    <Slate editor={editor} value={initialValue} onChange={onChange}>
      <EditorContext>
        <DocumentControlBar interpolations={interpolations} />
        <Separator weight={6} />
        <Panel noPadding radius={0.4} maxWidth={50} width="100%" margin="auto" shadow="light3" noBorder>
          <Editable
            onKeyDown={useEditorKeydown(editor)}
            renderElement={renderElement}
            renderLeaf={renderLeaf}
            style={{ minHeight: '100rem', padding: '1cm' }}
          />
        </Panel>
      </EditorContext>
    </Slate>
  )
}

export default MarkdownEditor
